/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { pageViewsByGaId } from '../fn/user-statistics/page-views-by-ga-id';
import { PageViewsByGaId$Params } from '../fn/user-statistics/page-views-by-ga-id';
import { UserStatisticsPageViewsResponse } from '../models/user-statistics-page-views-response';

@Injectable({ providedIn: 'root' })
export class UserStatisticsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `pageViewsByGaId()` */
  static readonly PageViewsByGaIdPath = '/rest/user/pageviews-by-gaid/{GAId}';

  /**
   * Get count of pageviews by google analytics id for last 30 days.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pageViewsByGaId()` instead.
   *
   * This method doesn't expect any request body.
   */
  pageViewsByGaId$Response(params: PageViewsByGaId$Params, context?: HttpContext): Observable<StrictHttpResponse<UserStatisticsPageViewsResponse>> {
    return pageViewsByGaId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get count of pageviews by google analytics id for last 30 days.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pageViewsByGaId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pageViewsByGaId(params: PageViewsByGaId$Params, context?: HttpContext): Observable<UserStatisticsPageViewsResponse> {
    return this.pageViewsByGaId$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserStatisticsPageViewsResponse>): UserStatisticsPageViewsResponse => r.body)
    );
  }

}
